<template>
  <div class="system">
	<img src="../../assets/img/404.png">
	<div class='title'>
        <h2>网站维护中...</h2>
        <h4>为了让您更好的使用系统，我们正在对服务器进行升级，升级期间暂时无法访问。</h4>
        <h4>给您带来的不便，敬请谅解！</h4>
    </div>
</div>
</template>

<script>
export default {

}
</script>

<style scoped lang='scss'>
/deep/ .content-box {
    padding-top: 0px;
}

.system {
    width: 100%;
    height: 100vh;
    background: #7395FF;
    text-align: center;
    color: white;

    img {
        position: relative;
        width: 1000px;
        margin-top:10vh ;
    }
    h2{
        font-size: 45px;
        height: 100px;
        line-height: 100px;
    }
    h4{
        font-size: 23px;
        line-height: 1.5;
    }
}
</style>
